<template>
  <div class="signIn">
    <amplify-authenticator username-alias="email">
      <amplify-sign-in
        slot="sign-in"
        :hide-sign-up="true"
        username-alias="email"
      >
      </amplify-sign-in>
    </amplify-authenticator>
  </div>
</template>

<script>
import "@aws-amplify/ui-vue";
import { Auth, Hub } from "aws-amplify";
// import { AmplifyEventBus } from "aws-amplify-vue";
export default {
  data() {
    return {
      authConfig: {
        signInConfig: {
          isSignUpDisplayed: false,
        },
      },
      username: "",
      message: {
        showError: false,
        errorMessage: null,
        show: false,
        message: null,
      },
    };
  },
  async created() {
    Hub.listen("auth", async (state) => {
      if (state.payload.event === "signIn") {
        await this.$store.dispatch("authAction");
        // this.$cookie.set(
        //   "AWSTOKEN",
        //   data.signInUserSession.accessToken.jwtToken,
        //   { expires: "1Y", domain: "hpapps.healthyperformance.co.uk" }
        // );
        this.$store.state.signedIn = true;
        // this.$store.state.user = data;
        const { payload } = state;
        const cognitoGroups =
          payload.data.signInUserSession.accessToken.payload["cognito:groups"];
        // console.log(cognitoGroups, "groups");
        if (cognitoGroups.includes("ADMIN")) {
          // console.log("ADMIN USER");
          this.$router.push({ path: "/operations" }, () => {});
        } else if (
          cognitoGroups.includes("SERVICE") ||
          cognitoGroups.includes("DELIVERY")
        ) {
          // console.log("SERVICE/DELIVERY USER");
          this.$router.push({ path: "/consultant" }, () => {});
        } else {
          // console.log("NO USER");
          Auth.signOut()
            .then((data) => {
              this.$router.push({ path: "login" });
            })
            .catch((err) => console.log(err));
        }
      } else {
        this.$store.state.signedIn = false;
      }
    });
    // this.findUser();
  },
  methods: {
    // async findUser() {
    //   const user = await Auth.currentAuthenticatedUser()
    //     .then((data) => {
    //       // this.$cookie.set(
    //       //   "AWSTOKEN",
    //       //   data.signInUserSession.accessToken.jwtToken,
    //       //   { expires: "1Y", domain: "hpapps.healthyperformance.co.uk" }
    //       // );
    //       this.$store.state.signedIn = true;
    //       this.$store.state.user = data;
    //       this.$router.push({ path: "/consultant" }, () => {});
    //     })
    //     .catch((err) => {
    //       this.$store.state.signedIn = false;
    //       console.log(err);
    //     });
    // },
  },
  computed: {
    signedIn() {
      return this.$store.state.signedIn;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
